import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { AppBar, Toolbar, Button, Link, Box, Stack, Typography } from "@mui/material";
import { Link as ScrollLink } from "react-scroll";

import logoUrl from "../../../assets/images/logo-svg1.svg";
import logoDrMonitora from '../../../assets/images/drmonitora-logo-branca.svg'

export function HeaderDrMonitora() {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="fixed">
        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Link component={RouterLink} to="/" sx={{ width: { xs: '100%', sm: '100%', md: 'auto', lg: 'auto' } }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: { xs: 'center', sm: 'center', md: 'flex-start', lg: 'flex-start' },
                width: "100%",
                height: { xs: "30px", sm: "30px", md: "45px", lg: "45px" },
              }}
            >
              <Box
                src={logoUrl}
                alt="Logo WashPass"
                component={'img'}
                sx={{
                  width: { xs: 'auto', sm: 'auto', md: '70%', lg: '70%' },
                  height: 'auto'
                }}
              />

              <Typography
                component={'hr'}
                sx={{
                  backgroundColor: '#FFF',
                  height: '100%',
                  width: '0.5px',
                  opacity: 0.7,
                  marginLeft: '0.9rem',
                  marginRight: { xs: '7px', sm: '7px', md: 0, lg: 0 }
                }}
              />

              <Box
                src={logoDrMonitora}
                alt="Logo Dr Monitora"
                component={'img'}
                sx={{
                  width: { xs: 'auto', sm: 'auto', md: '100%', lg: '100%' },
                  height: '100%'
                }}
              />
            </Box>
          </Link>
          <Box
            sx={{ display: { xs: "none", md: "flex" } }}
            className="App-link"
          >
            <Stack direction="row" spacing={2}>
              <ScrollLink
                to="vantagens"
                hashSpy={true}
                smooth={true}
                duration={500}
                offset={-1950}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <Button color="inherit">Como funciona</Button>
              </ScrollLink>
              <ScrollLink
                to="vantagens"
                hashSpy={true}
                smooth={true}
                duration={500}
                offset={-220}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <Button color="inherit">Vantagens</Button>
              </ScrollLink>
            </Stack>
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
